import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { stampCardSorterAtom, expandStoreStampIdAtom } from '../atoms/stampAtoms';

function useStampCards() {
    const { t } = useTranslation('stamp');
    const sorter = useAtomValue(stampCardSorterAtom);
    const setShopId = useSetAtom(expandStoreStampIdAtom);
    const { pop } = useFlow();
    const toast = useToast();
    const { data, status } = useQuery(queries.stamps.cardList(sorter));
    useEffect(() => {
        if (status === 'error') {
            pop();
            toast.error(t('error.loadFailed'));
        }
    }, [status]);
    useEffect(() => {
        if (data && data.cards.length > 0) {
            setShopId(data.cards[0].shopId);
        }
    }, [data]);
    return data;
}

export default useStampCards;
